import styled from 'styled-components';

// TODO(prototype): minimal inline styling. Replace with theme tokens once
// the production design system tokens are confirmed.

export const SCompareWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 16px 0;
`;

export const SCompareCard = styled.div<{ $variant?: 'primary' | 'secondary' }>`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  padding: 16px;
  border-color: ${({ $variant }) =>
    $variant === 'primary' ? '#10b981' : '#e5e7eb'};

  .compare-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .compare-card__pill {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 999px;
    background: ${({ $variant }) =>
      $variant === 'primary' ? '#d1fae5' : '#fef3c7'};
    color: ${({ $variant }) =>
      $variant === 'primary' ? '#065f46' : '#92400e'};
    text-transform: uppercase;
  }
`;

export const SFieldRow = styled.div<{ $diff?: boolean; $strike?: boolean }>`
  display: grid;
  grid-template-columns: 140px 1fr 20px;
  gap: 8px;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: 0;
  }

  .field-label {
    color: #6b7280;
    font-size: 12px;
    text-transform: uppercase;
  }

  .field-value {
    color: #111827;
    text-decoration: ${({ $strike }) => ($strike ? 'line-through' : 'none')};
    color: ${({ $strike }) => ($strike ? '#9ca3af' : '#111827')};
  }

  .field-indicator {
    color: ${({ $diff }) => ($diff ? '#f59e0b' : '#10b981')};
    text-align: right;
  }
`;

export const SCompareFooter = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #e5e7eb;
  color: #6b7280;
  font-size: 12px;
`;

export const SActionBar = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const SStatusBadge = styled.span<{ $tone: string }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  background: ${({ $tone }) => $tone === 'green' && '#d1fae5'};
  color: ${({ $tone }) => $tone === 'green' && '#065f46'};
  background-color: ${({ $tone }) => {
    if ($tone === 'green') return '#d1fae5';
    if ($tone === 'red') return '#fee2e2';
    if ($tone === 'yellow') return '#fef3c7';
    if ($tone === 'gray') return '#f3f4f6';
    if ($tone === 'blue') return '#dbeafe';
    return '#f3f4f6';
  }};
  color: ${({ $tone }) => {
    if ($tone === 'green') return '#065f46';
    if ($tone === 'red') return '#991b1b';
    if ($tone === 'yellow') return '#92400e';
    if ($tone === 'gray') return '#374151';
    if ($tone === 'blue') return '#1e40af';
    return '#374151';
  }};
`;

export const SExpandedRow = styled.div`
  padding: 16px 24px;
  background: #fafafa;
  border-left: 3px solid #3b82f6;
`;

export const SMergeProgress = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
`;

export const SWarningText = styled.div`
  color: #dc2626;
  font-size: 13px;
  margin-top: 12px;
`;

// Override the ui-kit Tabs' default content padding (theme.tabSpacingPaddingContent)
// for this page only — the CardContent wrapping each tab body already provides
// the visual frame, so the extra inner padding doubles up. The `&&` doubles
// the styled-component's auto-generated class to outrank the ui-kit's rule.
export const STabsWrapper = styled.div`
  && .ant-tabs-content-holder {
    padding: 0;
  }
`;

export const SToolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 12px 0;
`;
